import type { ReactElement } from 'react';

import { CatalogSelect } from '@/components/ui/CatalogSelect';
import { useCatalog } from '@/lib/quality-catalogs';

import type { TimeStudyFilters } from '../types';

// Filtros de Análisis (so=420, spec §4.2): rango de fechas del día de negocio y, con
// permiso de catálogos, tipo de documento y proceso. Todo el estado vive en la URL; los
// controles son su reflejo. Mobile-first sin desborde (G1-6): cada grupo ocupa el ancho
// y sus campos se reparten en columnas que pueden encogerse; un nombre largo de tipo o
// proceso se recorta con puntos suspensivos en lugar de empujar la página.

interface Props {
  filters: TimeStudyFilters;
  companyId: string;
  canFilterCatalogs: boolean;
  onChange: (patch: Partial<TimeStudyFilters>) => void;
  /** "Limpiar filtros": solo si algún filtro difiere del defecto (G1-6). */
  onClear?: () => void;
}

export function AnalysisFilters({
  filters,
  companyId,
  canFilterCatalogs,
  onChange,
  onClear,
}: Props): ReactElement {
  const scope = { companyId, enabled: canFilterCatalogs };
  const types = useCatalog('document-types', scope);
  const areas = useCatalog('process-areas', scope);
  return (
    <div className="filters tsfilters">
      <div className="daterange" role="group" aria-label="Rango de fechas">
        <label className="fld">
          <span>Desde</span>
          <input
            type="date"
            value={filters.desde}
            onChange={(e) => e.target.value !== '' && onChange({ desde: e.target.value })}
          />
        </label>
        <label className="fld">
          <span>Hasta</span>
          <input
            type="date"
            value={filters.hasta}
            onChange={(e) => e.target.value !== '' && onChange({ hasta: e.target.value })}
          />
        </label>
      </div>
      {canFilterCatalogs && (
        <div className="daterange" role="group" aria-label="Filtros del documento">
          <CatalogSelect
            label="Tipo de documento"
            value={filters.tipo}
            items={types.data}
            failed={types.isError}
            onRetry={() => void types.refetch()}
            onChange={(tipo) => onChange({ tipo })}
          />
          <CatalogSelect
            label="Proceso"
            value={filters.area}
            items={areas.data}
            failed={areas.isError}
            onRetry={() => void areas.refetch()}
            onChange={(area) => onChange({ area })}
          />
        </div>
      )}
      {onClear !== undefined && (
        <button type="button" className="btn ghost sm tsclear" onClick={onClear}>
          Limpiar filtros
        </button>
      )}
    </div>
  );
}
